import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'

import { PAGINATION } from '../../common/constants'
import { apolloService } from '../../common/services'

import { TRANSFER_DICTIONARY_WORD_TO_INGREDIENT_MUTATION } from '../graphql/mutations'
import { TRANSFER_DICTIONARY_WORD_TO_INGREDIENT } from '../redux/action-types'

const useTransferDictionaryWordToIngredientMutation = (
  type,
  refetchLastEvent,
) => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store =>
    get(store.dictionaryWords.data, type.fieldName, {}),
  )

  const mutate = useCallback(
    async (id, keyword, filters, page, pageSize) => {
      await apolloService.mutate(
        TRANSFER_DICTIONARY_WORD_TO_INGREDIENT_MUTATION,
        {
          id,
          keyword,
          filters: { ...filters, type: type.value },
          page: page || PAGINATION.DEFAULT_PAGE,
          pageSize: pageSize || PAGINATION.DEFAULT_PAGE_SIZE,
        },
        dispatch,
        TRANSFER_DICTIONARY_WORD_TO_INGREDIENT,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent, type.value],
  )

  return [mutate, { isLoading, error }]
}

export default useTransferDictionaryWordToIngredientMutation
